<template>
  <div v-if="show"
       class="vip-gift-btn"
       @click="handleClick"
  >
    <ym-icon class="icon"
             name="vip-gift"
    />
    赠送
  </div>
</template>

<script>
  export default {
    name: 'VipGiftBtn',
    props: {
      show: Boolean,
      id: {
        type: Number,
        required: true,
      },
      disabled: Boolean,
    },
    methods: {
      async handleClick() {
        const { disabled } = this;
        if (disabled) return;

        this.$emit('click');
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '~@/assets/styles/var.less';

  .vip-gift-btn {
    flex-basis: 80px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    color: @color-text-base;
    font-size: @font-size-extra-small;
    line-height: 1;

    .icon {
      margin-bottom: 8px;
      font-size: @font-size-extra-large;
    }
  }
</style>
